import { render, staticRenderFns } from "./PhotoCardParallel.vue?vue&type=template&id=80390fee&scoped=true&"
import script from "./PhotoCardParallel.vue?vue&type=script&lang=js&"
export * from "./PhotoCardParallel.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCardParallel.vue?vue&type=style&index=0&id=80390fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80390fee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80390fee')) {
      api.createRecord('80390fee', component.options)
    } else {
      api.reload('80390fee', component.options)
    }
    module.hot.accept("./PhotoCardParallel.vue?vue&type=template&id=80390fee&scoped=true&", function () {
      api.rerender('80390fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PhotoCardParallel.vue"
export default component.exports